import { Injectable } from '@angular/core';
import { FilterChip } from '@compumark/brand-context-components';

@Injectable()
export class FilterOperationService {
  public removeUnlockedFilters(
    currentFilterModel: {
      [key: string]: any;
    },
    lockedChips: FilterChip[],
    lockableFields: string[],
  ): void {
    this.removeNonLockableFields(currentFilterModel, lockableFields);
    this.filterSetValues(currentFilterModel, lockedChips);
    this.filterCustomCheckboxArrayValues(currentFilterModel, lockedChips);
    this.filterCustomTextValues(currentFilterModel, lockedChips);
    this.filterDateAndContainsValues(currentFilterModel, lockedChips);
    this.filterAgTextValues(currentFilterModel, lockedChips);
  }

  private removeNonLockableFields(
    currentFilterModel: { [key: string]: any },
    lockableFields: string[],
  ): void {
    Object.keys(currentFilterModel).forEach((field) => {
      if (!lockableFields.includes(field)) {
        delete currentFilterModel[field];
      }
    });
  }

  private filterSetValues(
    currentFilterModel: { [key: string]: any },
    lockedChips: FilterChip[],
  ): void {
    this.filterValues(currentFilterModel, lockedChips, 'set', 'values');
    this.filterValuesForClassesFilters(
      currentFilterModel,
      lockedChips,
      'CLASSES',
    );
  }

  private filterCustomCheckboxArrayValues(
    currentFilterModel: { [key: string]: any },
    lockedChips: FilterChip[],
  ): void {
    this.filterValues(
      currentFilterModel,
      lockedChips,
      'customCheckboxArray',
      'filter',
    );
  }
  private filterCustomTextValues(
    currentFilterModel: { [key: string]: any },
    lockedChips: FilterChip[],
  ): void {
    this.filterValuesForTextCustomFilters(
      currentFilterModel,
      lockedChips,
      'custom',
    );
  }

  private filterValues(
    currentFilterModel: { [key: string]: any },
    lockedChips: FilterChip[],
    filterType: string,
    valueKey: string,
  ): void {
    Object.keys(currentFilterModel).forEach((field) => {
      const filter = currentFilterModel[field];
      if (filter.filterType === filterType) {
        const newValues = filter[valueKey].filter((value: string) =>
          lockedChips.some(
            (chip) => chip.field === field && chip.value === value,
          ),
        );

        if (newValues.length) {
          filter[valueKey] = newValues;
        } else {
          delete currentFilterModel[field];
        }
      }
    });
  }
  private filterValuesForTextCustomFilters(
    currentFilterModel: { [key: string]: any },
    lockedChips: FilterChip[],
    filterType: string,
  ): void {
    Object.keys(currentFilterModel).forEach((field) => {
      const filter = currentFilterModel[field];
      if (filter.filterType === filterType) {
        const isLocked = lockedChips.some(
          (chip) => chip.field === field && chip.value === filter?.filter,
        );
        if (!isLocked) {
          delete currentFilterModel[field];
        }
      }
    });
  }
  private filterValuesForClassesFilters(
    currentFilterModel: { [key: string]: any },
    lockedChips: FilterChip[],
    filterType: string,
  ): void {
    Object.keys(currentFilterModel).forEach((field) => {
      const filter = currentFilterModel[field];
      if (filter?.type?.toLowerCase() === filterType.toLowerCase()) {
        const isLocked = lockedChips.some((chip) => chip.field === field);
        if (!isLocked) {
          delete currentFilterModel[field];
        }
      }
    });
  }

  private filterDateAndContainsValues(
    currentFilterModel: { [key: string]: any },
    lockedChips: FilterChip[],
  ): void {
    this.filterValuesByType(currentFilterModel, lockedChips, 'date');
    this.filterValuesByType(
      currentFilterModel,
      lockedChips,
      'CONTAINS',
      'type',
    );
  }
  public filterAgTextValues(
    currentFilterModel: { [key: string]: any },
    lockedChips: FilterChip[],
  ): void {
    this.filterValuesByType(currentFilterModel, lockedChips, 'text');
  }

  private filterValuesByType(
    currentFilterModel: { [key: string]: any },
    lockedChips: FilterChip[],
    filterType: string,
    typeKey: string = 'filterType',
  ): void {
    Object.keys(currentFilterModel).forEach((field) => {
      const filter = currentFilterModel[field];
      if (filter?.[typeKey]?.toLowerCase() === filterType.toLowerCase()) {
        const isLocked = lockedChips.some((chip) => chip.field === field);
        if (!isLocked) {
          delete currentFilterModel[field];
        }
      }
    });
  }
}
